import styled from 'styled-components';
import { space } from '@scriba/ui-lib';

export const Section = styled('section')`
  &:nth-child(n+1) {
    margin-top: ${space('xxl')}px;
  }
`;
